import { useMemo as d, useState as q, useEffect as z } from "react";
import { useCalendarContext as G } from "./atoms-v2766.js";
import { getTodaysDateTimeAtStart as J } from "./atoms-v21180.js";
import { getCellTime as K } from "./atoms-v259.js";
import { getIsMinSelectionOverflowCell as L, getIsHighlightedOverflowCell as Q } from "./atoms-v21181.js";
function _({ dateConfig: i, month: m, weekdayIdx: O }) {
  const { userInteractions: l } = G(), e = d(() => i.cellUID, [i]), [C, R] = q(null), t = d(
    () => (l == null ? void 0 : l.hoveredCell) === e,
    [l == null ? void 0 : l.hoveredCell, e]
  ), A = d(
    () => (l == null ? void 0 : l.startingCell) === e,
    [l == null ? void 0 : l.startingCell, e]
  ), p = d(
    () => (l == null ? void 0 : l.endingCell) === e,
    [l == null ? void 0 : l.endingCell, e]
  ), x = d(
    () => (l == null ? void 0 : l.endOfRangeActiveCell) === e,
    [l == null ? void 0 : l.endOfRangeActiveCell, e]
  ), D = d(
    () => l == null ? void 0 : l.consideredCells.includes(e),
    [l == null ? void 0 : l.consideredCells, e]
  ), b = d(
    () => l == null ? void 0 : l.selectedCells.includes(e),
    [l == null ? void 0 : l.selectedCells, e]
  ), k = d(
    () => D || b,
    [D, b]
  ), c = d(
    () => !(C != null && C.available) || K(e) < J(),
    [C, e]
  ), h = d(
    () => l == null ? void 0 : l.disabledBySelectionBoundsCells.includes(e),
    [l, e]
  ), w = d(
    () => l == null ? void 0 : l.disabledByMaxSelectionBoundsCells.includes(e),
    [l, e]
  ), F = d(
    () => l == null ? void 0 : l.disabledByMinSelectionBoundsCells.includes(e),
    [l, e]
  ), g = d(() => !!(i != null && i.isPreviousMonth), [i]), S = d(() => !!(i != null && i.isNextMonth), [i]), o = d(
    () => g || S,
    [g, S]
  ), E = d(
    () => (l == null ? void 0 : l.checkoutDateCell) === e,
    [e, l == null ? void 0 : l.checkoutDateCell]
  ), H = d(
    () => (l == null ? void 0 : l.disabledByMinSelectionBoundsCells.at(-1)) === e,
    [e, l == null ? void 0 : l.disabledByMinSelectionBoundsCells]
  ), U = d(
    () => (l == null ? void 0 : l.consideredCells.at(-1)) === e,
    [e, l == null ? void 0 : l.consideredCells]
  ), T = d(
    () => L(
      C,
      i,
      m,
      o,
      l
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      C,
      o,
      l == null ? void 0 : l.disabledByMinSelectionBoundsCells,
      l.startingCellData,
      l.endOfRangeActiveCellData
    ]
  ), N = d(
    () => Q(
      C,
      m,
      g,
      S,
      o,
      l
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      C,
      o,
      l.consideredCells,
      l.startingCellData,
      l.endOfRangeActiveCellData
    ]
  ), s = d(() => {
    const v = (l == null ? void 0 : l.consideredCells) ?? [];
    if (!v.length)
      return !1;
    const B = l == null ? void 0 : l.integratedDataStore;
    return B ? v.some((a) => {
      var y, f;
      return !((f = (y = B.get(a)) == null ? void 0 : y.cellData) != null && f.available);
    }) : !1;
  }, [l == null ? void 0 : l.consideredCells, l == null ? void 0 : l.integratedDataStore]), M = d(
    () => D && s && (l == null ? void 0 : l.checkoutDateCell) !== e,
    [D, s, l == null ? void 0 : l.checkoutDateCell, e]
  ), P = d(
    () => D,
    [D]
  ), j = d(
    () => c || h || o || M,
    [c, h, o, M]
  );
  return z(() => {
    var v, B, a;
    R(((a = (B = (v = l == null ? void 0 : l.integratedDataStore) == null ? void 0 : v.get) == null ? void 0 : B.call(v, e)) == null ? void 0 : a.cellData) ?? null);
  }, [l == null ? void 0 : l.integratedDataStore, e]), {
    cellData: C,
    cellUID: e,
    hasUnavailableInConsideredRange: s,
    isBridgeDateInclusive: k,
    isCheckoutDate: E,
    isConsideredBridgeDate: D,
    isConsideredBridgeDateEffective: P,
    isDisabledByMaxSelectionBoundsCells: w,
    isDisabledByMinSelectionBoundsCells: F,
    isDisabledForAvailability: c,
    isDisabledForNextMonth: S,
    isDisabledForOverflow: o,
    isDisabledForPreviousMonth: g,
    isDisabledForRange: h,
    isDisabledInclusive: j,
    isEndDate: p,
    isEndOfActiveRangeCell: x,
    isHighlightedOverflowCell: N,
    isHoverDisabledByUnavailable: M,
    isHovered: t,
    isMinSelectionOverflowCell: T,
    isRightSideBoundaryOfConsideredBridgeDates: U,
    isRightSideBoundaryOfMinSelectionRange: H,
    isSelectedBridgeDate: b,
    isStartDate: A,
    weekdayIdx: O
  };
}
export {
  _ as useCellState
};
